// extracted by mini-css-extract-plugin
export default {"container":"xtj0wY","footer":"k5HZpo"};